// src/page_index.ts
import { initializeSharedComponents } from './shared-init';
import { apiCall } from './api';
import { getUser } from './auth';
import { loadAndDisplayDailyLog } from './components/dailylog';

// Initialize shared components (header, announcements, etc.)
initializeSharedComponents('index');

const els = {
  counter: document.getElementById('counter') as HTMLSpanElement,
  contentContainer: document.getElementById('content-container') as HTMLElement,
  dailylogContainer: document.getElementById('dailylog-container') as HTMLElement,
};

async function loadCounter() {
  try {
    const data = await apiCall<{ num_hits: number }>('GET', '/api/counter', {
      params: { a: 'Hit counter' },
    });
    els.counter.textContent = String(data.num_hits);
  } catch (e: unknown) {
    els.counter.textContent = 'error';
  }
}

async function refreshPageContent() {
  const user = await getUser();

  if (user) {
    // User is authenticated - show daily log
    els.contentContainer.style.display = 'none';
    els.dailylogContainer.style.display = 'block';
    await loadAndDisplayDailyLog();
  } else {
    // User is not authenticated - show sign-in message
    els.contentContainer.style.display = 'block';
    els.dailylogContainer.style.display = 'none';
  }
}

// Load page-specific content
await loadCounter();
await refreshPageContent();

// Listen for auth state changes
window.addEventListener('auth-state-changed', () => {
  refreshPageContent();
});


